import ModelFactory from 'business/models/ModelFactory';
import { BaseTreeDataSupplier } from './BaseTreeDataSupplier';
import { TreeService } from 'business/services/TreeService';

class AdvancedSearchTreeDataSupplier implements BaseTreeDataSupplier {
  async getTreeNodes(id: number) {
    const ser: TreeService = ModelFactory(TreeService, false, true);
    const children = await ser.getAdvancedSearchTreeNodesService(id);

    if (children === null) {
      return null;
    }

    return children;
  }
}

export default AdvancedSearchTreeDataSupplier;
